// extracted by mini-css-extract-plugin
export default {"envelope":"MessagingEnvelope_envelope__ftZd+","indicator":"MessagingEnvelope_indicator__U45s7"};